import { InvoiceItemTypeEnum, ProductTypeEnum } from '@monetize/types/app';

export const getInvoiceTemplateGrid = (
  hideAdditionalInfo: boolean,
  hideDiscount: boolean,
) => {
  let variableColumnCount = 4;
  if (hideDiscount && hideAdditionalInfo) {
    variableColumnCount = 2;
  } else if (hideDiscount || hideAdditionalInfo) {
    variableColumnCount = 3;
  }
  return `3fr 2fr repeat(${variableColumnCount}, 1fr)`;
};

export const getInvoiceHeaderCells = (
  hideAdditionalInfo: boolean,
  hideDiscount: boolean,
) => {
  const headerCells = [
    'Offering',
    'Date',
    'Quantity',
    'Discount',
    'Additional Info',
    'Amount',
    '',
  ];
  return headerCells.filter((cell) => {
    if (cell === 'Discount' && hideDiscount) {
      return false;
    }
    if (cell === 'Additional Info' && hideAdditionalInfo) {
      return false;
    }
    return true;
  });
};

export const initinvoice = {
  account: {
    id: '',
    accountName: '',
  },
  fromCompany: {
    name: '',
    address: {
      line1: '',
      line2: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
    },
  },
  amount: 0,
  amountCredited: 0,
  amountDue: 0,
  amountPaid: 0,
  amountWithoutTax: 0,
  billGroupId: '',
  billingContact: [],
  collectionAttempts: 0,
  currency: '',
  createDate: '',
  dueDate: '',
  endDate: '',
  exchangeRate: '',
  id: '',
  invoiceItems: [],
  invoicingDate: '',
  locale: '',
  netTermsDays: 0,
  notes: [],
  orderId: '',
  paid: false,
  paidDate: '',
  pastDue: false,
  quoteId: '',
  payments: [],
  startDate: '',
  status: '',
  tax: 0,
  testAccount: true,
  amountWithoutDiscount: 0,
  discount: 0,
  credits: [],
};

export const initInvoiceItems = {
  addonId: '',
  amount: 0,
  amountCredited: 0,
  amountWrittenOff: 0,
  amountWithoutDiscount: 0,
  description: '',
  discount: 0,
  discountId: '',
  discounts: [],
  id: '',
  isAddon: false,
  multiTier: false,
  offeringId: '',
  offeringName: '',
  offeringDescription: '',
  priceModel: '',
  productId: '',
  productName: '',
  productType: ProductTypeEnum.ADVANCE,
  prorationMultiplier: 0,
  quantity: 0,
  quoteItemId: '',
  rateId: '',
  rateName: '',
  referenceId: null,
  subscription: false,
  subscriptionItemId: '',
  subscriptionId: '',
  type: InvoiceItemTypeEnum.SUBSCRIPTION,
  writeOffDate: '',
};

export const invoiceBillDateSettingsTooltipTitle =
  'Determine which date to use as the Invoice Bill Date';

export const invoiceBillDateSettingsTooltipItems = [
  '"Billing Anniversary" is based on when the invoice is generated and is normally the first day for the subscription period if billed in advance, or the day after the subscription period if billed in arrears.',
  '"Closest date within invoicing period" will ensure the Bill Date always falls within the subscription period.',
  '"Closest date within usage period" will ensure the Bill Date always falls within the usage period.',
];
